'use client'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import OverallResultsTable from './overall-results-table'

export default function GroupedResultsTables({
  groups,
  selectedSplits,
  selectedCarClassId = 'all',
  ...tableProps
}) {
  const visible = groups.filter(
    (group) =>
      (selectedSplits == null ||
        !group.hasSplitGrouping ||
        selectedSplits.includes(group.splitId)) &&
      (group.carClassId == null ||
        selectedCarClassId === 'all' ||
        group.carClassId === selectedCarClassId),
  )
  const table = (group) => (
    <OverallResultsTable
      {...tableProps}
      display={group.display}
      selectedCarClassId={selectedCarClassId}
      scope={group.scope}
      showSplits={group.showSplits}
      showClassBadges={group.showClasses}
      tableLabel={group.title}
    />
  )
  if (visible.length === 0)
    return <p role="status">No results for the selected filters.</p>
  if (visible.length === 1 && visible[0].scope === 'Overall')
    return table(visible[0])
  return (
    <Accordion
      key={visible
        .map((group) => group.id + ':' + Boolean(group.display.rows.length))
        .join('|')}
      type="multiple"
      defaultValue={visible
        .filter((group) => group.display.rows.length)
        .map((group) => group.id)}
      className="flex flex-col gap-4"
    >
      {visible.map((group) => (
        <AccordionItem key={group.id} value={group.id}>
          <AccordionTrigger>{group.title}</AccordionTrigger>
          <AccordionContent>{table(group)}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  )
}
